import { useEffect, useRef, useContext } from 'react'
import { State } from './utils/context'
import { loadBook } from './utils/data'
import Controls from './blocks/controls'
import Verses from './blocks/verses'
import Buttons from './blocks/buttons'
import Keyboard from './blocks/keyboard'

const App = () => {
  const self = useRef()
  const target = useRef()
  const [{input, output, active}, setState] = useContext(State)

  useEffect(() => {
    if (self.current || !Object.keys(output).length) {
      setState(state => ({
        ...state,
        output: {},
        status: 'loading',
        active: {
          ...state.active,
          verses: {}
        }
      }))

      scrollTo({top: 0})

      loadBook(input.bible, input.book)
      .then(book => setState(state => {
        if (state.input !== input) return state

        const chapters = Object.values(book).filter(verses => Object.keys(verses).length).length
        const data = book[input.chapter]

        // Przekłady różnią się podziałem na rozdziały (np. Ml 4 w KJV to Ml 3,19-24 w BT),
        // więc nieistniejący rozdział zamieniamy na najbliższy dostępny.
        if (!Object.keys(data ?? {}).length) return chapters ? {
          ...state,
          chapters,
          input: {
            ...state.input,
            chapter: Math.min(Math.max(1, input.chapter), chapters)
          }
        } : {...state, status: 'error'}

        const verses = state.target && Object.keys(data).filter(id => (
          state.target.some(([from, to]) => id >= from && id <= to)
        ))

        target.current = verses?.[0]

        return {
          ...state,
          output: data,
          chapters,
          status: 'done',
          target: null,
          active: {
            ...state.active,
            verses: verses ? Object.fromEntries(verses.map(id => [id, true])) : state.active.verses
          }
        }
      }))
      .catch(() => setState(state => state.input === input ? {...state, status: 'error'} : state))
    }
  }, [input])

  // Bez zależności, bo ponowne otwarcie tego samego rozdziału z cache nie zmienia `output`.
  useEffect(() => {
    if (target.current) {
      document.querySelector(`[data-id="${target.current}"]`)?.scrollIntoView({block: 'center'})
      target.current = null
    }
  })

  useEffect(() => {
    if (self.current) {
      setState(state => ({
        ...state,
        active: {
          ...state.active,
          control: {}
        }
      }))
    }
  }, [active.verses])

  useEffect(() => {
    self.current = true
  }, [])

  return (
    <>
      <Controls />
      <Verses />
      <Buttons />
      <Keyboard />
    </>
  )
}

export default App
